import request from '@/utils/service'

// 提现审核
export function listApi(data) {
  return request({
    url: '/walletWithdraw/list',
    method: 'get',
    params: data
  })
}

export function auditApi(data) {
  return request({
    url: '/walletWithdraw/audit',
    method: 'post',
    data
  })
}

export function xdWalletTxFlowApi(data) {
  return request({
    url: '/xdWalletTxFlow/list',
    method: 'get',
    params: data
  })
}


// 用户提现
export function userWithdrawalListApi(data) {
  return request({
    url: '/userWithdraw/list',
    method: 'post',
    params: data
  })
}
// 用户提现审核
export function userWithdrawAudtitApi(data) {
  return request({
    url: '/userWithdraw/userWithdrawAudtit',
    method: 'post',
    data,
    notUseQstring: true
  })
}


